import { motion } from "framer-motion";

// Real India outline path derived from public GeoJSON, projected into a 500x600 viewBox.
const INDIA_PATH =
  "M 170.4 78.6 L 187.6 97.5 L 186.0 110.6 L 192.4 118.8 L 191.9 127.1 L 180.3 124.9 L 184.9 142.6 L 200.7 152.8 L 223.0 164.1 L 212.8 171.3 L 206.6 186.4 L 222.1 192.5 L 237.3 200.4 L 258.3 209.4 L 280.3 211.5 L 289.6 219.6 L 302.0 221.2 L 321.4 224.9 L 334.8 224.7 L 336.6 218.3 L 334.5 208.1 L 335.7 201.2 L 345.5 197.8 L 346.9 210.4 L 347.2 213.7 L 361.8 219.8 L 372.0 217.2 L 385.5 218.3 L 398.7 217.8 L 399.8 208.0 L 393.2 202.8 L 406.2 200.8 L 420.8 188.9 L 439.4 178.6 L 452.9 182.6 L 464.3 175.8 L 471.9 185.8 L 466.4 192.6 L 483.8 195.0 L 485.0 201.1 L 479.4 204.0 L 480.7 213.9 L 469.2 211.0 L 448.4 222.1 L 448.9 231.3 L 440.0 244.8 L 439.2 252.6 L 432.0 265.9 L 419.4 262.2 L 418.8 278.9 L 415.2 284.3 L 416.9 291.2 L 408.9 295.0 L 400.5 269.5 L 396.0 269.5 L 393.4 279.8 L 384.6 271.5 L 389.6 262.3 L 396.8 261.4 L 404.2 247.8 L 394.9 245.0 L 380.0 245.3 L 364.7 243.1 L 363.3 231.9 L 355.6 231.1 L 342.8 224.1 L 337.2 235.1 L 348.8 243.6 L 338.7 249.6 L 335.1 255.4 L 345.0 259.7 L 342.3 269.4 L 347.9 281.5 L 350.4 294.8 L 348.1 300.6 L 337.1 300.4 L 317.3 303.8 L 318.2 315.9 L 309.7 325.4 L 286.5 336.2 L 268.5 355.1 L 256.4 365.3 L 240.4 375.8 L 240.4 383.2 L 232.4 387.2 L 217.9 392.9 L 210.4 393.8 L 205.5 406.0 L 208.9 426.9 L 209.7 440.3 L 202.9 455.6 L 202.9 482.9 L 194.5 483.7 L 187.2 495.9 L 192.1 501.2 L 177.4 505.8 L 172.0 516.7 L 165.6 521.4 L 150.3 506.3 L 142.9 483.8 L 136.7 467.6 L 131.1 460.0 L 122.6 444.5 L 118.6 424.4 L 115.8 414.4 L 101.2 392.3 L 94.5 361.1 L 89.7 340.6 L 89.7 321.1 L 86.6 306.0 L 63.2 315.6 L 51.9 313.7 L 30.9 294.2 L 38.6 288.4 L 33.9 282.1 L 15.0 268.4 L 25.7 257.7 L 61.1 257.8 L 57.9 244.0 L 48.9 235.8 L 47.0 223.4 L 36.5 216.2 L 54.2 199.3 L 72.9 200.6 L 89.7 183.7 L 99.8 167.4 L 115.4 151.2 L 115.2 139.8 L 128.9 130.5 L 115.9 122.5 L 110.3 111.7 L 104.6 97.6 L 112.5 90.6 L 136.9 94.6 L 154.8 92.2 L 170.4 78.6 Z";

// City coordinates derived from same projection so they land on the outline.
const PUNE = { x: 106.3, y: 351.6, city: "Pune", state: "Maharashtra", labelDx: 12, labelDy: 5 };
const VADODARA = { x: 95.5, y: 290.7, city: "Vadodara", state: "Gujarat", labelDx: -70, labelDy: 5 };

// Subtle nationwide talent network dots (NOT offices)
const NETWORK = [
  { x: 160.3, y: 189.3, r: 3.2 }, // Delhi
  { x: 90.6, y: 342.7, r: 2.6 }, // Mumbai
  { x: 166.5, y: 440.8, r: 3.0 }, // Bangalore
  { x: 209.5, y: 439.1, r: 2.8 }, // Chennai
  { x: 339.6, y: 286.4, r: 3.0 }, // Kolkata
  { x: 180.8, y: 369.9, r: 2.8 }, // Hyderabad
  { x: 85.7, y: 279.2, r: 2.4 }, // Ahmedabad
  { x: 137.4, y: 216.7, r: 2.4 }, // Jaipur
  { x: 220.4, y: 217.7, r: 2.4 }, // Lucknow
  { x: 145.1, y: 489.7, r: 2.2 }, // Kochi
  { x: 298.8, y: 323.1, r: 2.4 }, // Bhubaneswar
  { x: 393.9, y: 229.0, r: 2.4 }, // Guwahati
  { x: 153.3, y: 155.2, r: 2.2 }, // Chandigarh
  { x: 190.5, y: 309.4, r: 2.4 }, // Nagpur
  { x: 138.5, y: 284.1, r: 2.2 }, // Indore
];

function CityMarker({ x, y, city, state, labelDx, labelDy, delay = 0 }) {
  return (
    <g transform={`translate(${x},${y})`}>
      <motion.circle
        r={22}
        fill="url(#markerGlow)"
        initial={{ opacity: 0, scale: 0.4 }}
        whileInView={{ opacity: 0.85, scale: 1 }}
        viewport={{ once: true, margin: "-10% 0px" }}
        transition={{ delay: delay + 0.2, duration: 0.9, ease: "easeOut" }}
      />
      <motion.circle
        r={6}
        fill="#0d9488"
        stroke="#ffffff"
        strokeWidth={2}
        initial={{ scale: 0 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true, margin: "-10% 0px" }}
        transition={{ delay: delay + 0.4, duration: 0.5, type: "spring", stiffness: 260 }}
      />
      <motion.circle
        r={6}
        fill="none"
        stroke="#0d9488"
        strokeWidth={1.5}
        initial={{ scale: 1, opacity: 0.8 }}
        animate={{ scale: [1, 2.4, 1], opacity: [0.8, 0, 0.8] }}
        transition={{ duration: 2.8, repeat: Infinity, ease: "easeOut", delay: delay + 0.6 }}
      />
      <text
        x={labelDx}
        y={labelDy}
        fontFamily="Syne, sans-serif"
        fontWeight={700}
        fontSize={13}
        fill="#0f172a"
      >
        {city}
      </text>
      <text
        x={labelDx}
        y={labelDy + 13}
        fontFamily="JetBrains Mono, monospace"
        fontSize={8}
        letterSpacing="1.4"
        fill="#64748b"
      >
        {state.toUpperCase()}
      </text>
    </g>
  );
}

function NetworkDot({ x, y, r, delay }) {
  return (
    <motion.circle
      cx={x}
      cy={y}
      r={r}
      fill="#14b8a6"
      initial={{ opacity: 0, scale: 0 }}
      whileInView={{ opacity: 0.6, scale: 1 }}
      viewport={{ once: true, margin: "-10% 0px" }}
      transition={{ delay, duration: 0.6, ease: "easeOut" }}
    />
  );
}

export default function Ecosystem() {
  return (
    <section
      id="ecosystem"
      className="relative py-28 sm:py-36"
      data-testid="ecosystem-section"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-14 items-end">
          <div className="col-span-12 lg:col-span-7">
            <div className="mb-3 font-mono-a text-[11px] uppercase tracking-[0.28em] text-teal-700">
              / 002 · Nationwide Talent Reach
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight leading-[1.05]">
              Talent Across India.
              <br />
              <span className="font-serif-a italic font-normal text-slate-500">
                Powered from Pune & Vadodara.
              </span>
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5">
            <p className="text-slate-600 text-base sm:text-lg leading-relaxed">
              From our teams in <span className="text-teal-700 font-semibold">Pune</span> and{" "}
              <span className="text-teal-700 font-semibold">Vadodara</span>, Visionary Staffing
              Solutions connects organisations with technology and professional talent across
              India — combining local recruiting expertise, technology-enabled sourcing and a
              growing nationwide talent network.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6">
          {/* Map card */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="col-span-12 lg:col-span-8 rounded-3xl border border-slate-200 bg-white p-6 sm:p-10 relative overflow-hidden shadow-[0_10px_30px_rgba(15,23,42,0.06)]"
            data-testid="india-map-card"
          >
            <div className="absolute -top-20 -right-20 h-64 w-64 rounded-full bg-teal-100/60 blur-3xl pointer-events-none" />

            <div className="flex items-center justify-between mb-4 relative flex-wrap gap-3">
              <div className="font-mono-a text-[10px] uppercase tracking-[0.28em] text-teal-700">
                India-Wide Sourcing
              </div>
              <div className="flex items-center gap-4 text-[10px] font-mono-a uppercase tracking-[0.22em] text-slate-500">
                <span className="flex items-center gap-1.5">
                  <span className="h-2 w-2 rounded-full bg-teal-600" />
                  Anchor city
                </span>
                <span className="flex items-center gap-1.5">
                  <span className="h-1.5 w-1.5 rounded-full bg-teal-400/80" />
                  Talent network
                </span>
              </div>
            </div>

            <div className="relative w-full aspect-[5/6] max-h-[560px] mx-auto">
              <svg
                viewBox="0 0 500 600"
                className="absolute inset-0 w-full h-full"
                fill="none"
                aria-labelledby="india-map-title"
                role="img"
              >
                <title id="india-map-title">India talent reach map</title>
                <defs>
                  <radialGradient id="markerGlow" cx="50%" cy="50%" r="50%">
                    <stop offset="0%" stopColor="#14b8a6" stopOpacity="0.35" />
                    <stop offset="100%" stopColor="#14b8a6" stopOpacity="0" />
                  </radialGradient>
                  <linearGradient id="lineFade" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0%" stopColor="#0d9488" stopOpacity="0.55" />
                    <stop offset="100%" stopColor="#14b8a6" stopOpacity="0.05" />
                  </linearGradient>
                  <linearGradient id="mapFill" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#ecfeff" stopOpacity="0.9" />
                    <stop offset="100%" stopColor="#f0fdfa" stopOpacity="0.4" />
                  </linearGradient>
                  <pattern
                    id="mapDots"
                    x="0"
                    y="0"
                    width="10"
                    height="10"
                    patternUnits="userSpaceOnUse"
                  >
                    <circle cx="1" cy="1" r="0.9" fill="#0f766e" opacity="0.18" />
                  </pattern>
                  <clipPath id="indiaClip">
                    <path d={INDIA_PATH} />
                  </clipPath>
                </defs>

                {/* Faint decorative grid */}
                {[...Array(11)].map((_, i) => (
                  <line
                    key={`v-${i}`}
                    x1={i * 50}
                    y1={0}
                    x2={i * 50}
                    y2={600}
                    stroke="#0f172a"
                    strokeOpacity="0.04"
                  />
                ))}
                {[...Array(13)].map((_, i) => (
                  <line
                    key={`h-${i}`}
                    x1={0}
                    y1={i * 50}
                    x2={500}
                    y2={i * 50}
                    stroke="#0f172a"
                    strokeOpacity="0.04"
                  />
                ))}

                {/* India fill */}
                <path d={INDIA_PATH} fill="url(#mapFill)" />
                {/* Dot texture clipped to India */}
                <rect
                  x="0"
                  y="0"
                  width="500"
                  height="600"
                  fill="url(#mapDots)"
                  clipPath="url(#indiaClip)"
                />
                {/* Animated India outline */}
                <motion.path
                  d={INDIA_PATH}
                  fill="none"
                  stroke="#0d9488"
                  strokeWidth={1.6}
                  strokeOpacity="0.7"
                  strokeLinejoin="round"
                  initial={{ pathLength: 0, opacity: 0 }}
                  whileInView={{ pathLength: 1, opacity: 1 }}
                  viewport={{ once: true, margin: "-10% 0px" }}
                  transition={{ duration: 2.2, ease: "easeOut" }}
                />

                {/* Connecting lines from anchor cities to network dots */}
                {NETWORK.map((n, i) => {
                  const from = i % 2 === 0 ? PUNE : VADODARA;
                  return (
                    <motion.line
                      key={`ln-${i}`}
                      x1={from.x}
                      y1={from.y}
                      x2={n.x}
                      y2={n.y}
                      stroke="url(#lineFade)"
                      strokeWidth={1}
                      initial={{ pathLength: 0, opacity: 0 }}
                      whileInView={{ pathLength: 1, opacity: 1 }}
                      viewport={{ once: true, margin: "-10% 0px" }}
                      transition={{ delay: 1.0 + i * 0.05, duration: 1.2, ease: "easeOut" }}
                    />
                  );
                })}

                {/* Network dots across the country */}
                {NETWORK.map((n, i) => (
                  <NetworkDot key={i} {...n} delay={0.6 + i * 0.05} />
                ))}

                {/* Anchor city markers */}
                <CityMarker {...VADODARA} delay={0.3} />
                <CityMarker {...PUNE} delay={0.5} />
              </svg>
            </div>
          </motion.div>

          {/* Right column: three supporting labels */}
          <div className="col-span-12 lg:col-span-4 flex flex-col gap-4">
            {[
              {
                tag: "Pune",
                title: "Technology Talent & Recruitment",
                testid: "reach-pune",
              },
              {
                tag: "Vadodara",
                title: "Recruitment & Delivery",
                testid: "reach-vadodara",
              },
              {
                tag: "India-Wide",
                title: "Talent Sourcing Network",
                testid: "reach-india-wide",
              },
            ].map((item, i) => (
              <motion.div
                key={item.tag}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10% 0px" }}
                transition={{ delay: i * 0.08, duration: 0.6, ease: "easeOut" }}
                className="vss-card p-6 sm:p-7 relative overflow-hidden"
                data-testid={item.testid}
              >
                <div className="font-mono-a text-[10px] uppercase tracking-[0.28em] text-teal-700 mb-2">
                  {item.tag}
                </div>
                <div className="font-display text-lg sm:text-xl font-bold text-slate-900 leading-snug">
                  {item.title}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
